import { useDispatch, useSelector } from "react-redux";

import DisplayAiDecision from "../../../../../Components/common/DisplayAiDecision/DisplayAiDecision";
import GenerateAiDecisionButton from "../../../../../Components/common/GenerateAiDecisionButton/GenerateAiDecisionButton";

import { RequestGenerateAgentAIDecision } from "../../../../../store/actions/integrationsActions";

import "./styles.scss";

const AiDecision = ({ id }) => {
  const dispatch = useDispatch();

  const aiDecision = useSelector((state) => state.integrations.generatedAgentAiDecision);
  const aiDecisionLoading = useSelector(
    (state) => state.integrations.generatedAgentAiDecisionLoading,
  );
  const generatingAiDecision = useSelector(
    (state) => state.integrations.generateAgentAiDecisionLoading,
  );

  const generateAIDecisionHandler = () => {
    if (!id) return;
    if (generatingAiDecision) return;
    dispatch(RequestGenerateAgentAIDecision(id));
  };

  return (
    <div className="thunter-ai-decision">
      <GenerateAiDecisionButton
        onClick={generateAIDecisionHandler}
        loading={generatingAiDecision}
        disabled={aiDecisionLoading}
      />

      <DisplayAiDecision
        aiDecision={aiDecision}
        aiDecisionLoading={aiDecisionLoading}
        generatingAiDecision={generatingAiDecision}
      />
    </div>
  );
};

export default AiDecision;
